<template>
    <div>
        <div id="qrCode" ref="qrCodeDiv"></div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
    name:'qrcode',
    data() {
        return {
            
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.bindQRCode();
        })
    },
    methods: {
       bindQRCode: function () {
        $("#qrcode").html('');
        new QRCode(this.$refs.qrCodeDiv, {
          text: this.$route.params.id,
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
        })
      }
    },
}
</script>
<style lang="less" scoped>
    #qrCode{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        -moz-transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        -o-transform: translate(-50%,-50%);
    }
</style>




// WEBPACK FOOTER //
// src/components/qrcode/code.vue